import React, { useEffect } from 'react';
import { Header } from 'components/home';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { ROUTES } from 'routes/constants';
import { useAuth } from 'contexts/auth/auth_context';
import { useNavigate, useLocation } from 'react-router-dom';
import useCifaStore from 'stores/cifa/cifa.store';
import MunicipalManagerCifa from './MunicipalManagerCifa';
import StateManagerCifa from './StateManagerCifa';

const PERMISSIONTOMANAGER = [
  'ADMINISTRADOR',
  'GERENTE ESTADUAL',
];

const ManageCifa: React.FC = () => {
  const location = useLocation();
  const { getCifa } = useCifaStore();
  const { user } = useAuth();

  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = /cifa-(\d{4})/.exec(location.pathname);
  const anoReferencia = match ? Number(match[1]) : 2026;

  const userPermission = user?.permission.name;
  const hasPermissionToManage = PERMISSIONTOMANAGER.includes(userPermission!);
  const isMunicipalManager = userPermission === 'MUNICIPAL MANAGER' || userPermission === 'GERENTE MUNICIPAL';
  const navigate = useNavigate();

  const getInfoCifa = async (instituicao: any) => {
    const response = await getCifa(instituicao!.uuid, anoReferencia);
    console.log('response', response);
  };

  useEffect(() => {
    const instituicao = user?.institution;

    if (!instituicao) {
      alert('Você não tem permissão para acessar esta página.');
      navigate(ROUTES.HOME);
    }

    if (isMunicipalManager) {
      getInfoCifa(instituicao);
    }


  }, []);

  return (
    <MenuProvider>
      <TopNavBar />
      <Header title={`Gerenciar CIFA - ${anoReferencia}`} showBackButton={true} />
      {isMunicipalManager && <MunicipalManagerCifa />}
      {hasPermissionToManage && <StateManagerCifa />}
    </MenuProvider>
  );
};

export default ManageCifa;
